import * as types from './types'
import { ToDoParams } from 'app/models/todo-params'
import { createReducer } from 'app/state/utils'
import { Generational, mutated, outdated } from 'app/state/utils/generation'


/**
 * Generation standard (utils/generation.ts), as the deal / facility / entity
 * grids: every write patches the rows from the ledger's answer and moves the
 * generation; a list read that started before such a write is dropped and
 * the store left stale, so a lagging PQS answer never undoes the patch.
 */
export interface ToDoState extends Generational {
  todos: ToDoParams[]
  todo?: ToDoParams
  isLoading: boolean
}

const initialState: ToDoState = {
  todos: [],
  todo: undefined,
  isLoading: false,
  generation: 0,
  stale: false,
}


const todosReducer = createReducer(initialState)({
  [types.GET_TODOS]: (
    state: ToDoState,
    action: { payload: { todos: ToDoParams[]; generation?: number } },
  ) => {
    // fetched before a write the store has since applied: these rows would
    // undo it. Drop them and leave the store stale; the tab reads once more.
    if (outdated(state, action.payload.generation)) return { ...state, stale: true }
    return { ...state, todos: action.payload.todos, stale: false }
  },
  [types.TODOS_LOAD_FAILED]: (state: ToDoState) => ({ ...state, stale: false }),
  [types.GET_TODO]: (state: any, payload: any) => {
    return { ...state, todo: payload.payload }
  },
  [types.ADD_TODOS]: (state: any, payload: any) => {
    return {
      ...state,
      todos: [payload.payload.data, ...state.todos],
      generation: mutated(state),
    }
  },
  [types.EDIT_TODOS]: (state: any, payload: any) => {
    const index = state.todos.findIndex(
      (todo: { id: any }) => todo.id === payload.payload.data.id
    )
    // the row as the ledger answered it; a row the store lacks is added
    const newArray = [...state.todos]
    if (index >= 0) newArray[index] = { ...payload.payload.data }
    else newArray.unshift({ ...payload.payload.data })
    return {
      ...state,
      todos: [...newArray],
      todo: { ...payload.payload.data },
      generation: mutated(state),
    }
  },
  [types.DELETE_TODOS]: (state: any, payload: any) => {
    const filteredTodos = state.todos.filter((todo: any) => {
      return todo.id !== payload.payload[0].id
    })

    return {
      ...state,
      todos: filteredTodos,
      generation: mutated(state),
    }
  },
  [types.START_LOADING_TODOS]: (state: ToDoState) => {
    return { ...state, isLoading: true }
  },
  [types.STOP_LOADING_TODOS]: (state: ToDoState) => {
    return { ...state, isLoading: false }
  },
})

export default todosReducer
